import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, { useState, useEffect } from "react";
import { api } from "../../../../api/api";
import makeStyles from "@mui/styles/makeStyles";
import SecretSantaFeedbackSendApproveDialog from "../../../dialog/SecretSantaFeedbackSendApproveDialog";
import { useSnackbar } from "notistack";


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },

}));

export function AdminControl(props) {
  const classes = useStyles();

  const [feedbackSendDialog, openFeedbackSendDialog] = useState(false);
  const [feedbackSendApprove, setFeedbackSendApprove] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const snackBarAddMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };


  const callSecretSantaChangeState = (state) => {
    let toState = state ? 'start' : 'finish';
    api.secretSanta.changeState(toState)
      .then(
        () => {
          props.setRequestSantaState(true)
          props.setReload(true)
        }
      )
      .catch((error) => {
        console.log(error)
        snackBarAddMessage(`Unable ${toState} secret santa, please check your permissions and try again. Error: ${error.status}`, 'error');
      })
  };

  useEffect(() => {
    if (feedbackSendApprove) {
      openFeedbackSendDialog(false)
      props.setBackdropOpen(true)
      api.sender.sendSecretSantasFeedback()
        .then(() => {
          setFeedbackSendApprove(false)
          props.setBackdropOpen(false)
        })
        .catch((error) => {
          console.log(error)
          snackBarAddMessage(`Unable make secret santa pairs, please check your permissions and try again. Error: ${error.status}`, 'error');
        })
        .finally(() => {
          props.setBackdropOpen(false)
        });
    }
  }, [feedbackSendApprove]);

  return <Paper className={classes.paper}>
    <SecretSantaFeedbackSendApproveDialog
      component={'span'}
      open={feedbackSendDialog}
      handleClose={() => openFeedbackSendDialog(false)}
      handleApprove={() => setFeedbackSendApprove(true)}
    />
    <Typography variant="h6" gutterBottom>
      Secret Santa
    </Typography>
    {/*{notificationSend ? <label color="red">Santa notifications have been sent!!</label> : false}*/}
    <br />
    <Button onClick={() => callSecretSantaChangeState(true)}
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={props.santaState !== 0}>Start Secret Santa</Button>
    <Button onClick={() => callSecretSantaChangeState(false)}
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={props.santaState === 0}>Finish Secret Santa</Button>

    <Button
      onClick={() => openFeedbackSendDialog(true)}
      variant="contained"
      color="primary"
      className={classes.button}
    >
      Send feedback requests
    </Button>
  </Paper>;
}
